<script>
	import PageHeader	from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Cartão do Síndico';
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">
	<img src="/assets/images/imgCartao_2.png" class="img-responsive">
	<p>Ganhe mais comodidade, agilidade, segurança e economia, com o Cartão do Síndico da Bona Imóveis. Trata-se de um cartão de crédito com a bandeira Visa/Itaú, sem ônus ao condomínio.</p>
	<p>Você que é síndico vai usufruir de inúmeras vantagens, tais como:</p>
	<ul class="list-cycle">
		<li>Fazer compras em nome do condomínio sem a necessidade de adiantamentos da administradora;</li>
		<li>Faturas debitadas diretamente na conta do condomínio;</li>
		<li>Evita o uso da conta corrente pessoal do síndico;</li>
		<li>Você ganha prazo e parcelamento das compras do condomínio;</li>
		<li>Elimina risco do transporte de valores pelo síndico e funcionários;</li>
		<li>Buscamos no seu condomínio através de motoboy, as notas das comprar efetuadas;</li>
	</ul>
	<p class="mt-30">Em caso de dúvidas, entre em <a href="/contato">contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/contato" class="btn btn-primary">Solicite mais informações <i class="far fa-arrow-right"></i></a>
	</div>
</div>